import { render, staticRenderFns } from "./OccurrencesConfig.vue?vue&type=template&id=2bfdcaf2&scoped=true&"
import script from "./OccurrencesConfig.vue?vue&type=script&lang=js&"
export * from "./OccurrencesConfig.vue?vue&type=script&lang=js&"
import style0 from "./OccurrencesConfig.vue?vue&type=style&index=0&id=2bfdcaf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdcaf2",
  null
  
)

export default component.exports